import { CalculateOptions } from '../entities/project-festival.entity';
import { projectFestivalSlice } from '../project-festival.slice';

export const setProjectFestivalCalculateOptions = (
  calculateOptions: CalculateOptions,
) => projectFestivalSlice.actions.setCalculateOptions(calculateOptions);
